export const CONTENT_WRAPPER_ID = 'pageLayoutWrapper';
